/**
 * StarRating Component
 *
 * Interactive 5-star rating input used in review wizards and edit forms.
 * Displays clickable stars with hover animation and current value.
 *
 * @param {object} props
 * @param {number} props.value - Current rating (0-5)
 * @param {function} props.onChange - Called with new rating when star is clicked
 * @param {string} props.label - Label text above the stars
 */
import { Star } from 'lucide-react';

export default function StarRating({ value, onChange, label }) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onChange(star)}
            className="focus:outline-none transition-transform hover:scale-110"
          >
            <Star
              className={`w-8 h-8 ${
                star <= value ? 'text-yellow-400 fill-current' : 'text-gray-300'
              }`}
            />
          </button>
        ))}
        {value > 0 && (
          <span className="ml-2 text-sm text-gray-600">{value}/5</span>
        )}
      </div>
    </div>
  );
}
